import { render, staticRenderFns } from "./FaqNoticeBar.vue?vue&type=template&id=2a9922e0&scoped=true&"
import script from "./FaqNoticeBar.vue?vue&type=script&lang=js&"
export * from "./FaqNoticeBar.vue?vue&type=script&lang=js&"
import style0 from "./FaqNoticeBar.vue?vue&type=style&index=0&id=2a9922e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9922e0",
  null
  
)

export default component.exports